<template>
	<div class="introduce">
		<!-- <Header></Header> -->
		<div class="introduce_main_box">
			<h5>信息定制</h5>
			<p>
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;国研网依托其传统的信息资源优势和专业的研究咨询团队，结合多年积累的庞大数据库资源和在政策研究、宏观经济、行业分析、战略规划和数据库建设等领域积累的丰富经验，在提供基础信息资源、集成信息资源（信息平台）、决策分析平台的基础上，针对用户在某领域全面专业信息的直接需求，提供专项信息定制服务。具体分类、说明及案例如下，欢迎垂询！<br />

				<strong style="margin-top:25px;display:block;"
					>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：400-7070-678
					E-mail：salse@drcnet.com.cn</strong
				>

				<strong style="margin-top:25px;display:block;"
					>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;信息定制服务类别说明及案例</strong
				>

				<el-table
					:data="tableData"
					border
					:cell-style="{
						'font-weight': 'bold',
						'font-size': '16px',
						'text-align': 'center',
						padding: '30px 10px',
					}"
					:header-cell-style="{
						'font-weight': 'bold',
						'font-size': '16px',
						'text-align': 'center',
					}"
					style="width:100%;margin:20px auto;"
				>
					<el-table-column prop="title" label="类别" width="180">
					</el-table-column>
					<el-table-column prop="name" label="服务内容" width="520">
					</el-table-column>
					<el-table-column prop="address" label="服务案例">
					</el-table-column>
				</el-table>
			</p>
		</div>
		<!-- <Footer></Footer> -->
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';

export default {
	props: {},
	components: {
		Header,
		Footer,
	},
	data() {
		return {
			tableData: [
				{
					title: '信息专题',
					name:
						'依托海量权威优质信源及时跟踪经济社会热点，精心策划若干选题，并精选高质量的信息，形成专题服务数据库，如研判经济大势，追踪热点问题，解读经济政策政策等。',
					address: '《两会专题信息服务》 《中办长期热点专题》',
				},
				{
					title: '信息专报',
					name:
						'依托多年的热点追踪积累及专业研究团队，跟踪经济社会发展中重要热点问题，并形成信息专报，如宏观经济、产业经济、贸易经济以及金融领域热点，从政策解读、重要数据以及发展动态提供全面的信息参考。',
					address:
						'《宏观经济周评》《绿金动态周刊》《双碳观察周刊》《中美贸易摩擦专报》',
				},
			],
		};
	},
	computed: {},
	methods: {},
	created() {},
	mounted() {},
};
</script>
<style scoped lang="less">
.introduce {
	width: 100%;
	height: 100%;
	background: #f2f2f2;
}
.introduce_main_box {
	width: 1200px;
	margin: 0 auto;
	min-height: 600px;
}
.introduce_main_box p {
	font-size: 16px;
	line-height: 2.5;
	margin-bottom: 70px;
	color: #202223;
	font-family: '微软雅黑', 'Heiti SC', '黑体', 'Arial';
}
.introduce_main_box h5 {
	width: 100%;
	text-align: center;
	font-size: 30px;
	font-weight: bold;
	margin: 60px 0 30px;
}
.introduce_main_box strong {
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/infor/index.vue